import React, { useState } from 'react';
import Card from '../components/Card';
import Filters from '../components/Filters';
import TagsHoc from '../components/hoc/TagsHoc';
import QACard from '../components/QACard';
import { useData } from '../context/DataContext';

function InformationPage() {
  const { data, todayLineup } = useData();

  const [activeFilters, setActiveFilters] = useState<string[]>([]);

  const filteredInfos = todayLineup.infos.filter(inf => {
    if (activeFilters.length === 0) return true;

    let filterCheck = true;

    activeFilters.forEach(filter => {
      switch (filter) {
        default: {
          if (data.collections.zones[filter]) {
            filterCheck = filterCheck && (inf.zoneIds.length === 0 || inf.zoneIds.includes(filter));
          }
          break;
        }
      }
    });

    return filterCheck;
  });

  const zoneKeys = Object.keys(data.collections.zones).map(e => data.collections.zones[e]._id);

  return (
    <div id="InformationPage">
      <Filters
        title={data.appConfig.INFORMATION_LABEL}
        icon={['far', 'info-circle']}
        keys={zoneKeys}
        onFilterChange={setActiveFilters}
        labelExtractor={(key: string) => data.collections.zones[key]?.name}
        rightSide={
          <div className="flex items-center -mr-4">
            <div className="px-4 font-semibold date-picker">{data.appConfig.TODAY_LABEL}</div>
          </div>
        }
      />
      <div className="grid gap-2 pb-8">
        {filteredInfos.map(info => (
          <TagsHoc type="basic" item={info} key={info.id}>
            {props =>
              info.appearance === 'questionAndAnswer' ? (
                <QACard
                  title={info.title}
                  description={info.description}
                  tags={props.tags}
                  callToActions={info.callToActions}
                />
              ) : (
                <Card
                  className="border-b"
                  title={info.title}
                  subtitle={info.description}
                  tags={props.tags}
                  callToActions={info.callToActions}
                />
              )
            }
          </TagsHoc>
        ))}
        {filteredInfos.length <= 0 && (
          <div className="italic text-slate px-4 pt-4 text-center no-text-footer">
            {data.appConfig.NO_RESULTS_TEXT}
          </div>
        )}
      </div>
    </div>
  );
}
export default InformationPage;
